import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo_edu_match.png'
import _imports_1 from '@/assets/logo.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-00d8fe6a")

_pushScopeId("data-v-00d8fe6a")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  src: _imports_0,
  alt: "エデュマッチ",
  class: "h-8 mb-10"
}
const _hoisted_3 = {
  key: 1,
  src: _imports_1,
  alt: "みんがく",
  class: "h-8 mb-10"
}
const _hoisted_4 = {
  key: 5,
  class: "mb-3"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("span", null, "独自アプリ管理", -1)
const _hoisted_6 = {
  key: 6,
  class: "mb-3"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("span", null, "成長ジャーナル", -1)
const _hoisted_8 = {
  key: 7,
  class: "mb-3"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("span", null, "心拍アラート設定", -1)
const _hoisted_10 = { class: "mb-3" }
const _hoisted_11 = /*#__PURE__*/_createVNode("span", null, "スクールAI管理", -1)
const _hoisted_12 = {
  key: 0,
  class: "block ml-6 text-gray-700 text-sm"
}
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 使い方は")
const _hoisted_14 = /*#__PURE__*/_createVNode("a", {
  href: "https://mingaku.notion.site/399ef296e7748097a319cef6b21b95e6",
  target: "_blank",
  class: "font-bold hover:text-gray-500"
}, "こちら", -1)
const _hoisted_15 = /*#__PURE__*/_createTextVNode("をご覧ください。 ")
const _hoisted_16 = {
  key: 0,
  class: "flex flex-col pb-12"
}
const _hoisted_17 = {
  href: "https://mingaku.net/guide/calendar",
  target: "_blank",
  rel: "noopener noreferrer",
  class: "flex items-center mb-3 text-gray-700 transition-all duration-300 hover:text-gray-500"
}
const _hoisted_18 = /*#__PURE__*/_createVNode("span", null, "開室カレンダー", -1)
const _hoisted_19 = {
  href: "https://mingaku.net/guide",
  target: "_blank",
  rel: "noopener noreferrer",
  class: "flex items-center mb-3 text-gray-700 transition-all duration-300 hover:text-gray-500"
}
const _hoisted_20 = /*#__PURE__*/_createVNode("span", null, "公式ガイド", -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("span", { class: "text-gray-400 text-sm" }, "© みんがく", -1)
const _hoisted_22 = {
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  class: "w-6 h-6 text-white"
}
const _hoisted_23 = { d: "M6 18L18 6M6 6l12 12" }
const _hoisted_24 = { d: "M4 6h16M4 12h16M4 18h16" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_MNavItem = _resolveComponent("MNavItem")
  const _component_m_icon = _resolveComponent("m-icon")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("nav", {
      class: ["flex flex-shrink-0 flex-col justify-between h-screen w-64 px-8 pt-4 pb-8 border-r-4 border-primary-100 bg-white absolute lg:relative z-20 lg:z-0 shadow-xl lg:shadow-none transition-transform duration-500 transform -translate-x-full lg:translate-x-0", _ctx.dynamicCss]
    }, [
      _createVNode("div", null, [
        (_ctx.isRoleLoaded && !_ctx.isExclusiveSchoolAiUser)
          ? (_openBlock(), _createBlock("div", _hoisted_1, [
              (!(_ctx.isCramSchool || _ctx.isAdmin))
                ? (_openBlock(), _createBlock("img", _hoisted_2))
                : (_openBlock(), _createBlock("img", _hoisted_3))
            ]))
          : _createCommentVNode("", true),
        _createVNode("ul", null, [
          _createVNode(_component_MNavItem, {
            text: "ホーム",
            icon: "house-door",
            link: "/home",
            selected: _ctx.current == 'home'
          }, null, 8, ["selected"]),
          _createVNode(_component_MNavItem, {
            text: "生徒情報",
            icon: "users",
            link: "/student",
            selected: _ctx.current == 'student'
          }, null, 8, ["selected"]),
          _createVNode(_component_MNavItem, {
            text: "通知メッセージ",
            icon: "notification",
            link: "/notification",
            selected: _ctx.current == 'notification'
          }, null, 8, ["selected"]),
          (!(_ctx.isAdmin || _ctx.isExclusiveSchoolAiUser))
            ? (_openBlock(), _createBlock(_component_MNavItem, {
                key: 0,
                text: "提出BOX",
                icon: "book",
                link: "/submission_master",
                selected: _ctx.current == 'submission'
              }, null, 8, ["selected"]))
            : _createCommentVNode("", true),
          (!_ctx.isExclusiveSchoolAiUser)
            ? (_openBlock(), _createBlock(_component_MNavItem, {
                key: 1,
                text: "学習室情報",
                icon: "calender",
                link: "/room",
                selected: _ctx.current == 'room'
              }, null, 8, ["selected"]))
            : _createCommentVNode("", true),
          (_ctx.isAdminOfSchool || _ctx.isSupervisorOfSchool)
            ? (_openBlock(), _createBlock(_component_MNavItem, {
                key: 2,
                text: "スタッフ管理",
                icon: "staff",
                link: "/staff",
                selected: _ctx.current == 'staff'
              }, null, 8, ["selected"]))
            : _createCommentVNode("", true),
          (_ctx.isAdminOfSchool)
            ? (_openBlock(), _createBlock(_component_MNavItem, {
                key: 3,
                text: "教室管理",
                icon: "building",
                link: "/classroom",
                selected: _ctx.current == 'classroom'
              }, null, 8, ["selected"]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin || _ctx.isServiceProvider)
            ? (_openBlock(), _createBlock(_component_MNavItem, {
                key: 4,
                text: "導入スクール管理",
                icon: "building",
                link: "/school",
                selected: _ctx.current == 'school'
              }, null, 8, ["selected"]))
            : _createCommentVNode("", true),
          (_ctx.isAdmin || _ctx.isAdminOfSchool)
            ? (_openBlock(), _createBlock("li", _hoisted_4, [
                _createVNode(_component_router_link, {
                  to: "/mini_app",
                  rel: "noopener noreferrer",
                  class: ["flex items-center mb-1 text-gray-500 transition-all duration-300 hover:text-primary-500", { 'text-primary-500': _ctx.$route.path.includes('mini_app') }]
                }, {
                  default: _withId(() => [
                    _createVNode(_component_m_icon, {
                      type: "mini-app",
                      class: "mr-2 w-3"
                    }),
                    _hoisted_5
                  ]),
                  _: 1
                }, 8, ["class"])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isAdmin)
            ? (_openBlock(), _createBlock("li", _hoisted_6, [
                _createVNode(_component_router_link, {
                  to: "/journals",
                  rel: "noopener noreferrer",
                  class: ["flex items-center mb-1 text-gray-500 transition-all duration-300 hover:text-primary-500", { 'text-primary-500': _ctx.$route.path.includes('journals') }]
                }, {
                  default: _withId(() => [
                    _createVNode(_component_m_icon, {
                      type: "book",
                      class: "mr-2 w-3"
                    }),
                    _hoisted_7
                  ]),
                  _: 1
                }, 8, ["class"])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isAdmin && _ctx.schoolConfig?.data.canUseLearningCard)
            ? (_openBlock(), _createBlock("li", _hoisted_8, [
                _createVNode(_component_router_link, {
                  to: "/heart_rate_alert_setting",
                  rel: "noopener noreferrer",
                  class: ["flex items-center mb-1 text-gray-500 transition-all duration-300 hover:text-primary-500", {
              'text-primary-500': _ctx.$route.path.includes(
                'heart_rate_alert_setting'
              )
            }]
                }, {
                  default: _withId(() => [
                    _createVNode(_component_m_icon, {
                      type: "heart",
                      class: "mr-2 w-3"
                    }),
                    _hoisted_9
                  ]),
                  _: 1
                }, 8, ["class"])
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_10, [
            _createVNode("a", {
              href: `${_ctx.schoolAIUrl}`,
              target: "_blank",
              rel: "noopener noreferrer",
              class: "flex items-center mb-1 text-gray-700 transition-all duration-300 hover:text-gray-500"
            }, [
              _createVNode(_component_m_icon, {
                type: "smile",
                class: "mr-2 w-3"
              }),
              _hoisted_11
            ], 8, ["href"]),
            (!_ctx.isExclusiveSchoolAiUser)
              ? (_openBlock(), _createBlock("span", _hoisted_12, [
                  _hoisted_13,
                  _hoisted_14,
                  _hoisted_15
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      (!_ctx.isExclusiveSchoolAiUser)
        ? (_openBlock(), _createBlock("div", _hoisted_16, [
            _createVNode("a", _hoisted_17, [
              _createVNode(_component_m_icon, {
                type: "calender",
                class: "mr-2"
              }),
              _hoisted_18
            ]),
            _createVNode("a", _hoisted_19, [
              _createVNode(_component_m_icon, {
                type: "external",
                class: "mr-2"
              }),
              _hoisted_20
            ]),
            _hoisted_21
          ]))
        : _createCommentVNode("", true)
    ], 2),
    _createVNode("span", {
      class: "fixed bottom-4 right-4 w-12 h-12 z-50 flex items-center justify-center bg-black rounded-full shadow-xl cursor-pointer transition-all duration-300 hover:bg-gray-700 lg:hidden",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showMenu = !_ctx.showMenu))
    }, [
      (_openBlock(), _createBlock("svg", _hoisted_22, [
        _withDirectives(_createVNode("path", _hoisted_23, null, 512), [
          [_vShow, _ctx.showMenu]
        ]),
        _withDirectives(_createVNode("path", _hoisted_24, null, 512), [
          [_vShow, !_ctx.showMenu]
        ])
      ]))
    ])
  ], 64))
})